import React, { useState, useRef, useEffect } from "react";
import { MdOutlineAddAPhoto } from "react-icons/md";
import { HiOutlineTrash } from "react-icons/hi2";
import Button from "../UI/Button";
import { useSelector } from "react-redux";
import { LuFilePlus2, LuFileCheck2 } from "react-icons/lu";

const WhatsAppForm = ({ formData, setFormData, setFormDataFiles }) => {
    const [bookingConfirmationImage, setBookingConfirmationImage] = useState(null);
    const [headsUpImage, setHeadsUpImage] = useState(null);
    const [feedbackDoc, setFeedbackDoc] = useState(null);

    const bookingInputRef = useRef(null);
    const headsUpInputRef = useRef(null);
    const feedbackDocInputRef = useRef(null);

    const storedFormFiles = useSelector((state) => state.formDataFiles);

    useEffect(() => {
        if (storedFormFiles && Object.keys(storedFormFiles).length > 0) {
            if (storedFormFiles.booking_confirmation_image && Object.keys(storedFormFiles.booking_confirmation_image).length > 0) {
                // console.log("here",storedFormFiles.coverImage.preview.startsWith("https" || "blob"))
                if (
                    storedFormFiles.booking_confirmation_image?.preview?.startsWith("https") ||
                    storedFormFiles.booking_confirmation_image?.preview?.startsWith("blob")
                ) {
                    setBookingConfirmationImage(storedFormFiles.booking_confirmation_image);
                } else {
                    const image = { ...storedFormFiles.booking_confirmation_image };
                    if (image.preview) {
                        image.preview = `${process.env.REACT_APP_API_URL}` + image.preview;
                        setBookingConfirmationImage(image);
                    }
                }
            }

            if (storedFormFiles.heads_up_image && Object.keys(storedFormFiles.heads_up_image).length > 0) {
                // console.log("here",storedFormFiles.coverImage.preview.startsWith("https" || "blob"))
                if (
                    storedFormFiles.heads_up_image?.preview?.startsWith("https") ||
                    storedFormFiles.heads_up_image?.preview?.startsWith("blob")
                ) {
                    setHeadsUpImage(storedFormFiles.heads_up_image);
                } else {
                    const image = { ...storedFormFiles.heads_up_image };
                    if (image.preview) {
                        image.preview = `${process.env.REACT_APP_API_URL}` + image.preview;
                        setHeadsUpImage(image);
                    }
                }
            }

            if (storedFormFiles.feedbackDoc && Object.keys(storedFormFiles.feedbackDoc).length > 0) {
                // console.log("here",storedFormFiles.coverImage.preview.startsWith("https" || "blob"))
                console.log("feedbackDoc", storedFormFiles.feedbackDoc)
                if (
                    storedFormFiles.feedbackDoc?.preview?.startsWith("https") ||
                    storedFormFiles.feedbackDoc?.preview?.startsWith("blob")
                ) {
                    setFeedbackDoc(storedFormFiles.feedbackDoc);
                } else {
                    const image = { ...storedFormFiles.feedbackDoc };
                    if (image.preview) {
                        image.preview = `${process.env.REACT_APP_API_URL}` + image.preview;
                        setFeedbackDoc(image);
                    }
                }
            }
        }
    }, [storedFormFiles])

    useEffect(() => {
        if (bookingConfirmationImage?.preview) {
            setFormData((prev) => ({ ...prev, bookingConfirmationImage: bookingConfirmationImage.preview }));
            setFormDataFiles((prev) => ({ ...prev, booking_confirmation_image: bookingConfirmationImage }));
        }
        if (bookingConfirmationImage == null) {
            setFormData((prev) => ({ ...prev, bookingConfirmationImage: "null" }));
        }
    }, [bookingConfirmationImage]);

    useEffect(() => {
        if (headsUpImage?.preview) {
            setFormData((prev) => ({ ...prev, headsUpImage: headsUpImage.preview }));
            setFormDataFiles((prev) => ({ ...prev, heads_up_image: headsUpImage }));
        }
        if (headsUpImage == null) {
            setFormData((prev) => ({ ...prev, headsUpImage: "null" }));
        }
    }, [headsUpImage]);

    useEffect(() => {
        console.log("DOC", feedbackDoc)
        if (feedbackDoc) {
            setFormData((prev) => ({ ...prev, feedbackDoc: feedbackDoc?.preview }));
            setFormDataFiles((prev) => ({ ...prev, feedback_doc: feedbackDoc?.file }));
        }
        if (feedbackDoc == null) {
            setFormData((prev) => ({ ...prev, feedbackDoc: "null" }));
        }
    }, [feedbackDoc]);

    const handleFileSelect = (e, setter) => {
        const file = e.target.files[0];
        if (!file) return;

        setter({
            file,
            preview: URL.createObjectURL(file),
        });
    };

    const renderImageInput = (label, imageState, setter, inputRef) => (
        <div className="grid grid-rows-1 lg:grid-cols-3 grid-cols-1 mb-6">
            <h2 className="section_heading">{label}</h2>

            {!imageState?.preview ? (
                <div className="bg-white col-span-2 relative rounded-xl border-2 border-[#dad3c3] border-dashed py-10 flex flex-col justify-center items-center gap-2">
                    <MdOutlineAddAPhoto size={35} />

                    <label>
                        <Button text={`Add Image`} handleClick={() => inputRef.current.click()} />
                        <input
                            type="file"
                            ref={inputRef}
                            accept="image/png, image/jpeg"
                            className="hidden"
                            onChange={(e) => handleFileSelect(e, setter)}
                        />
                    </label>
                </div>
            ) : (
                <div className="col-span-1">
                    <div
                        style={{
                            backgroundImage: `url(${imageState.preview})`,
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            paddingBottom: "66.67%",
                            borderRadius: "0.75rem",
                            aspectRatio: "1/1",
                        }}
                        className="relative overflow-hidden"
                    />

                    <div
                        onClick={() => setter(null)}
                        className="flex justify-self-end mt-2 text-sm text-black items-center gap-1 px-2 py-1 rounded-md cursor-pointer"
                    >
                        <span>Remove</span>
                        <HiOutlineTrash size={20} />
                    </div>
                </div>
            )}
        </div>
    );

    const renderPDFInput = (label, fileState, setter, inputRef) => (
        <div className="grid grid-rows-1 lg:grid-cols-3 grid-cols-1 mb-6">
            <h2 className="section_heading">{label}</h2>

            {!fileState?.preview ? (
                <div className="bg-white col-span-2 relative rounded-xl border-2 border-[#dad3c3] border-dashed py-10 flex flex-col justify-center items-center gap-2">
                    <LuFilePlus2 size={35} />

                    <label>
                        <Button text={`Add PDF`} handleClick={() => inputRef.current.click()} />
                        <input
                            type="file"
                            ref={inputRef}
                            accept="application/pdf"
                            className="hidden"
                            onChange={(e) => handleFileSelect(e, setter)}
                        />
                    </label>
                </div>
            ) : (
                <div className="col-span-2">
                    <div className="flex w-full items-center justify-between px-4 py-2 rounded-xl border-2 border-[#dad3c3] bg-white">
                        <div className="flex items-center gap-2">
                            <LuFileCheck2 size={20} />
                            <h4 className="text-[14px] font-medium max-w-52 md:max-w-sm overflow-hidden text-ellipsis">
                                {fileState.file?.name || (typeof fileState.preview === "string" ? (fileState.preview.split("/").pop() === "null" ? "No file selected." : fileState.preview.split("/").pop()) : "Selected Document")}
                            </h4>
                        </div>
                    </div>
                    <div
                        onClick={() => setter(null)}
                        className="flex justify-self-end mt-2 text-sm text-black items-center gap-1 px-2 py-1 rounded-md cursor-pointer"
                    >
                        <span>Remove</span>
                        <HiOutlineTrash size={20} />
                    </div>
                </div>
            )}
        </div>
    );

    return (
        <div className={'mt-6 pb-16'}>
            {renderImageInput(
                "Booking Confirmation Template Image",
                bookingConfirmationImage,
                setBookingConfirmationImage,
                bookingInputRef
            )}

            {renderImageInput(
                "Heads Up Template Image",
                headsUpImage,
                setHeadsUpImage,
                headsUpInputRef
            )}
            {renderPDFInput(
                "Feedback Template Document",
                feedbackDoc,
                setFeedbackDoc,
                feedbackDocInputRef
            )}
        </div>
    );
};

export default WhatsAppForm;
